import { Injectable, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { OfferService } from './offer.service';
import { DataLayersService } from './data-layers.service';
import { LoaderService } from './loader.service';
import { CONECTAS_ROUTE_MAP } from 'src/app/shared/bc-connect/interfaces/conectas-route-map'
declare var $: any;
@Injectable({
  providedIn: 'root'
})
export class LoadService {
  title: any;
  text: any;
  closebtn: any;
  redirectOnClose: any;
  redirectSSO: any;
  micro: string = "none";
  microO: string = "none";
  // app-micro-loader se suscribe a esto y llama detectChanges() el mismo; un tick() global
  // de ApplicationRef no garantiza llegar a esa vista cuando scripts de ads de terceros
  // interfieren con zone.js.
  readonly microChanged = new Subject<void>();
  // Mismo problema para #confirmationModalV2: app-modal se suscribe y llama detectChanges(),
  // porque loadingSoftFilter/stepConfirmTelephone se actualizan dentro de un subscribe HTTP
  // cuya vista a veces no refresca sola (p.ej. al reabrir el modal para una segunda oferta).
  readonly confirmModalChanged = new Subject<void>();
  enableButtons: string = 'block';
  cellphone: any;
  isConectaFail: boolean = false;
  isConectaRejected: boolean = false;
  typeNoOffers = 1;

  //variables flujo buscacredito conecta
  public imgBcConectaDesktop = "";
  public imgBcConectaMobile = "";
  public imgsBcConecta = {
    'd_success': "assets/images/modals/d_bc_conecta_success.png",
    'm_success': "assets/images/modals/m_bc_conecta_success.png",
    'd_fail': "assets/images/modals/d_bc_conecta_fail.png",
    'm_fail': "assets/images/modals/m_bc_conecta_fail.png"
  }
  public isInProcess: boolean = false;
  public showBcConecta: boolean = false;

  // Constantes para tiempos de espera en milisegundos
  private readonly MODAL_DELAYS = {
    BODY_CLASS_APPLY: 300,    // Delay para aplicar clases al body después de cerrar modal anterior
    REDIRECT_DELAY: 7000,      // Tiempo antes de redirigir al cerrar modal
    AUTO_CLOSE: 30000,         // Tiempo para auto-cerrar el modal
    SHOW_CONFIRM_TIMEOUT: 1000 // Tiempo máximo para confirmar que un modal se visualizó
  } as const;

  // Array para almacenar funciones de limpieza de event listeners
  private modalCleanupFunctions: (() => void)[] = [];

  constructor(private router: Router, public offer: OfferService,
    private dataLayerService: DataLayersService,

    private loaderService: LoaderService) {
    this.title = "";
    this.text = "";
    this.closebtn = false;
    this.redirectOnClose = "";
    this.cellphone = localStorage.getItem('userPhone');
    this.imgBcConectaDesktop = this.imgsBcConecta.d_success;
    this.imgBcConectaMobile = this.imgsBcConecta.m_success;

    // Verificar si hay un estado de loader pendiente después de refresh
    const showLoaderAfterRefresh = sessionStorage.getItem('showLoaderNoOfertas');
    if (showLoaderAfterRefresh === 'true') {
      sessionStorage.removeItem('showLoaderNoOfertas');
      // Mostrar el loader de cortina azul inmediatamente
      setTimeout(() => {
        this.loaderService.open();
        // Redirigir después de mostrar el loader
        setTimeout(() => {
          this.offer.clearOfferlocalStorage();
          window.location.href = '/ofertas';
        }, 1500);
      }, 7000);
    }
  }

  close(modal: any, shorTimeout = false) {
    let time = 1000;
    if (shorTimeout) {
      time = 100;
    }
    setTimeout(() => {
      this.title = '';
      this.text = '';
      this.closebtn = false;

      // Remover el foco de cualquier elemento dentro del modal antes de cerrarlo
      const modalElement = $(modal);
      const focusedElement = modalElement.find(':focus');
      if (focusedElement.length > 0) {
        (focusedElement[0] as HTMLElement).blur();
      }

      // Cerrar el modal
      $(modal).modal('hide');

      // Limpiar backdrop
      $('.modal-backdrop').removeClass("show");
      $('.modal-backdrop').addClass("hide");
      setTimeout(() => {
        $('.modal-backdrop').remove();
      }, 150);

      // Restaurar el scroll del body
      $('body').removeClass("modal-open");
      $('body').css({ "padding-right": "", "overflow": "" });

      // Limpiar aria-hidden si quedó en el modal
      $(modal).removeAttr('aria-hidden');

      if (this.redirectOnClose != undefined) {
        this.redirectOnClose != "" ? this.redirectPage(this.redirectOnClose) : this.router.navigate([this.redirectOnClose]);

      }
    }, time);
  }

  /**
   * Método para  la limpieza completa de todos los modales y restaurar el scroll
   * Útil cuando hay problemas de foco atrapado o scroll bloqueado
   */
  forceCleanupModals() {
    // Remover todos los backdrops
    $('.modal-backdrop').remove();

    // Cerrar todos los modales abiertos
    $('.modal').modal('hide');
    $('.modal').removeAttr('aria-hidden');

    // Restaurar completamente el body
    $('body').removeClass('modal-open');
    $('body').css({
      'padding-right': '',
      'overflow': '',
      'overflow-y': ''
    });

    // Limpiar cualquier foco atrapado
    if (document.activeElement && document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }

    // Asegurar que el foco vuelva al body
    document.body.focus();
  }

  open(modal: any, title: any, text: any, close: any, redirect: any) {
    this.title = title;
    this.text = text;
    this.closebtn = close;
    this.redirectOnClose = redirect;

    // Limpiar backdrops residuales y estado del body antes de abrir un nuevo modal
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open').css({ 'padding-right': '', 'overflow': '' });

    $(modal).modal({
      show: true,
      keyboard: false,
      backdrop: 'static'
    });

    if (modal === '#noOfertasModal') {
      this.setupNoOfertasModal(modal);
    } else if (modal === '#confirmationModalV2') {
      this.setupConfirmationModal(modal);
    }
  }

  openNotValidateSoftFilters(modal: any, title: any, text: any, close: any, redirect: any) {
    this.title = title;
    this.text = text;
    this.closebtn = close;
    this.redirectOnClose = redirect;
    $(modal).modal({
      show: true,
      keyboard: false,
      backdrop: 'static'
    });

    if (modal === '#confirmationModalV2') {
      this.setupConfirmationModal(modal);
    }
  }

  redirectPage(page: any) {
    if (page.includes("http")) {
      window.location.href = encodeURI(page);
    } else {
      this.router.navigate([this.redirectOnClose]);
    }
  }

  closeMicro() {
    this.micro = "none";
    this.microChanged.next();
  }

  openMicro(text: any) {
    this.text = text;
    this.micro = "block";
    this.microChanged.next();
  }
  closeMicroO() {
    this.microO = "none";
  }

  openMicroO(text: any) {
    this.text = text;
    this.microO = "block";
  }

  closePopUp(indicativo: string) {
    if (indicativo == 'btn') {
      const o = this.offer.offerSelected;
      this.dataLayerService.dl_eventoGA4_cancel_application(
        localStorage.getItem('productName'),
        localStorage.getItem('offerId'),
        localStorage.getItem('companyName'),
        DataLayersService.getOfferIsFeatured(o?.labelType ?? '0'),
        DataLayersService.getOfferLabel(o?.labelType ?? '0', o?.textLabel ?? ''),
        'Cancelar'
      );
    }
    this.offer.clearOfferlocalStorage();
    this.offer.errorPreselecta = false;
  }

  errorService() {

    this.offer.errorPreselecta = true;
    this.enableButtons = "block";
    this.closeMicro();
  }

  openBcConecta() {
    const nit = this.offer.offerSelected?.company?.id;
    const route = CONECTAS_ROUTE_MAP[nit];
    if (route) {
      this.router.navigate(['/conecta', route]);
      return;
    }
    setTimeout(() => {
      this.imgBcConectaDesktop = this.imgsBcConecta.d_success;
      this.imgBcConectaMobile = this.imgsBcConecta.m_success;
      $('#bcConectaModal').modal({
        show: true,
        keyboard: false,
        backdrop: 'static'
      });
      this.showBcConecta = true;
    }, this.MODAL_DELAYS.BODY_CLASS_APPLY);
  }

  /**
   * Configura el modal de confirmación
   */
  private setupConfirmationModal(modal: string): void {
    const $modal = $(modal);

    $modal.off('shown.bs.modal');

    const shownHandler = () => {
      this.applyBodyScrollLock();
      this.ensureBackdropVisibility();
    };

    $modal.on('shown.bs.modal', shownHandler);
  }

  private applyBodyScrollLock(): void {
    $('body').addClass('modal-open').css({
      'overflow': 'hidden',
      'padding-right': '0px'
    });
  }

  /**
   * Asegura que el backdrop del modal sea visible con la opacidad correcta
   * Crea el backdrop si no existe y aplica los estilos necesarios
   */
  private ensureBackdropVisibility(): void {
    const BACKDROP_STYLES = {
      opacity: '0.5',
      'background-color': '#000',
      display: 'block'
    };

    if ($('.modal-backdrop').length === 0) {
      $('body').append('<div class="modal-backdrop fade show"></div>');
    }

    $('.modal-backdrop')
      .removeClass('hide')
      .addClass('show fade')
      .css(BACKDROP_STYLES);
  }

  /**
   * Configura el modal de "no ofertas" con sus comportamientos específicos
   */
  private setupNoOfertasModal(modal: string): void {
    // Cleanup de listeners previos
    this.cleanupModalListeners();

    // Configurar body para modal
    this.configureBodyForModal();

    // Manejar refresh de página
    this.setupPageRefreshHandler(modal);
  }

  private configureBodyForModal(): void {
    setTimeout(() => {
      $('body').addClass('modal-open').css({
        'overflow': 'hidden',
        'padding-right': '0px'
      });
    }, this.MODAL_DELAYS.BODY_CLASS_APPLY);
  }

  /**
   * Redirige a la página principal de ofertas al cerrar el modal
   */
  private setupModalCloseHandler(modal: string): void {
    const $modal = $(modal);

    $modal.off('hidden.bs.modal');

    const closeHandler = () => {
      this.offer.clearOfferlocalStorage();
      this.router.navigate(['/ofertas']);
    };

    $modal.on('hidden.bs.modal', closeHandler);

    // Guardar función de limpieza
    this.modalCleanupFunctions.push(() => {
      $modal.off('hidden.bs.modal', closeHandler);
    });
  }

  /**
   * Guarda el estado en sessionStorage para mostrar el loader después del refresh
   */
  private setupPageRefreshHandler(modal: string): void {
    const $window = $(window);
    const $modal = $(modal);

    const beforeUnloadHandler = () => {
      if ($modal.hasClass('show')) {
        // Marcar para mostrar loader después del refresh
        sessionStorage.setItem('showLoaderNoOfertas', 'true');
        this.offer.clearOfferlocalStorage();
      }
    };

    $window.off('beforeunload').on('beforeunload', beforeUnloadHandler);

    // Guardar función de limpieza
    this.modalCleanupFunctions.push(() => {
      $window.off('beforeunload', beforeUnloadHandler);
    });
  }

  private scheduleAutoClose(modal: string): void {
    const timeoutId = setTimeout(() => {
      const $modal = $(modal);
      if ($modal.hasClass('show')) {
        $modal.modal('hide');
      }
    }, this.MODAL_DELAYS.AUTO_CLOSE);

    // Guardar función de limpieza para cancelar el timeout si es necesario
    this.modalCleanupFunctions.push(() => {
      clearTimeout(timeoutId);
    });
  }

  private cleanupModalListeners(): void {
    this.modalCleanupFunctions.forEach(cleanup => cleanup());
    this.modalCleanupFunctions = [];
  }

  openBancolombiaModal(): Promise<void> {
    this.showBcConecta = true;
    return new Promise<void>((resolve) => {
      setTimeout(() => {
        const $modal = $('#bancolombiaModal') as any;
        if ($modal.length === 0) {
          console.error('[LoadService] No se encontró el elemento #bancolombiaModal en el DOM');
          resolve();
          return;
        }
        $modal.off('shown.bs.modal.bancolombia');
        $modal.one('shown.bs.modal.bancolombia', () => {
          $('.modal-backdrop').addClass('modal-backdrop-blur');
          resolve();
        });
        $modal.modal({ show: true, keyboard: false, backdrop: 'static' });
      }, 600);
    });
  }

  closeBancolombiaModal() {
    this.showBcConecta = false;
    $('.modal-backdrop').removeClass('modal-backdrop-blur');
    ($('#bancolombiaModal') as any).modal('hide');
  }

  closeBcConecta() {
    this.imgBcConectaDesktop = this.imgsBcConecta.d_success;
    this.imgBcConectaMobile = this.imgsBcConecta.m_success;
    this.showBcConecta = false;
    this.close('#bcConectaModal', true);

    setTimeout(() => {
      this.forceCleanupModals();
    }, 200);

    // Asegurar limpieza del localStorage si es un rechazo
    if (this.isConectaRejected) {
      this.offer.clearOfferlocalStorage();
    }

    this.offer.errorPreselecta = false;
    if (this.isConectaFail) {
      this.isConectaFail = false;
      if (this.isConectaRejected) {
        let categorySel = this.offer.categoriesActive.find((element: any) => { return element.id == this.offer.offerSelected.detail.categoryId });
        this.offer.offersList = this.offer.offersList.filter((ele: any) => ele.idOffer != this.offer.offerSelected.idOffer);
        this.offer.offersFil = this.offer.offersFil.filter((ele: any) => ele.idOffer != this.offer.offerSelected.idOffer);
        this.offer.offerSelected = undefined;
        this.isConectaRejected = false;
        this.router.navigate(['/ofertas/' + categorySel.url]);
      }
      else if (this.router.url.toString().includes('aliado')) {
        let categorySel = this.offer.categoriesActive.find((element: any) => { return element.id == this.offer.offerSelected.detail.categoryId });
        this.router.navigate(['/ofertas/' + categorySel.url]);
      }
    }
    // if (this.router.url.toString().includes('aliado') && this.isConectaFail) {
    //   this.isConectaFail = false;
    //   if (this.isConectaRejected) {
    //     this.offer.offersList = this.offer.offersList.filter((ele: any) => ele.idOffer != this.offer.offerSelected.idOffer);
    //     this.offer.offersFil = this.offer.offersFil.filter((ele: any) => ele.idOffer != this.offer.offerSelected.idOffer);
    //     this.offer.offerSelected = undefined;
    //     this.isConectaRejected = false;
    //     this.router.navigate(['/ofertas/' + this.offer.categorySel.url]);
    //   } else {
    //     this.router.navigate(['/ofertas']);
    //   }
    // } else if(this.isConectaFail) {
    //   this.isConectaFail = false;
    //   if (this.isConectaRejected) {
    //     this.offer.offersList = this.offer.offersList.filter((ele: any) => ele.idOffer != this.offer.offerSelected.idOffer);
    //     this.offer.offersFil = this.offer.offersFil.filter((ele: any) => ele.idOffer != this.offer.offerSelected.idOffer);
    //     this.offer.offerSelected = undefined;
    //     this.isConectaRejected = false;
    //     this.router.navigate(['/ofertas/' + this.offer.categorySel.url]);
    //   }
    // }
  }

}
